import allWeekIds from './reducers';

export { default as updateAllWeekIdsByRetailerId } from './operations';
export default allWeekIds;
